import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'
import images from '../../../assets/images/awards/images'

const ec = LOCALE === "es-EC"
const arg = LOCALE === "es-AR"
const cl = LOCALE === "es-CL"

const Text1ByCountry = () => {
  let text;
  if (ec) {
    text = <p className='.f-content-awards-left__info-box --tex1-ec'>
      <b>Serán 2 fases,</b> donde podrás ganar desde un espectacular Kit Nosotras,
      hasta 1 Iphone 13.
    </p>
  } else if(arg){
    text = <p className='.f-content-awards-left__info-box'>
      <b>Serán 2 fases,</b> ganá desde un espectacular Kit Nosotras,
      hasta 1 Tablet.
    </p>
  }else if(cl){
    text = <p>
      <b>Serán 2 fases,</b> Gana desde un espectacular Kit Nosotras,
      hasta 1 Laptop.
    </p>
  }else{
    text = <p>
      <b>Serán 2 fases,</b> ganar desde un espectacular Kit Nosotras,
      hasta 1 Iphone 14.
    </p>
  }

  return (
    text
  )
}
const Text2ByCountry = () => {
  let text;
  if (arg) {
    text = <>
      <b>¡Guardá TODOS tus empaques!</b> La marca te los pedirá si llegás
      a ser ganadora y solo presentándolos recibirás tu premio.
      <b> Comenzá a ingresar tus claves personales,</b> jugá las veces
      que querás y ganá muchos premios.
    </>
  }else{
    text = <>
      <b>¡Guarda TODOS tus empaques!</b> La marca te los pedirá si llegas
      a ser ganadora y solo presentándolos recibirás tu premio.
      <b> Comienza a ingresar tus claves personales,</b> juega las veces
      que quieras y gana muchos premios.
    </>
  }

  return (
    text
  )
}
const Text3ByCountry = () => {
  let text;
  if (arg) {
    text = <>
      Corré a participar y <br /> <b> ¡ganá premios en cada fase!</b>
    </>
  }else{
    text = <>
      Corre a participar y <br /> <b> ¡gana premios en cada fase!</b>
    </>
  }

  return (
    text
  )
}
const rewardByCountry = () => {
  let text;
  if (ec) {
    text = <>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 1:</b> 1 Iphone 13
      </li>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 2:</b> 1 Ipad 9na generación
      </li>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 3 al 5: </b> 1 Kit de Productos + merchandising
      </li>
    </>
  } else if (arg) {
    text = <>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 1:</b> 1 Tablet
      </li>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 2:</b> Unos rollers (patines)
      </li>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 3 al 10: </b> 1 Kit de Productos Nosotras + merchandising
      </li>
    </>
  } else if (cl) {
    text = <>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 1:</b> 1 Laptop
      </li>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 2:</b> 1 Tablet
      </li>
      <li className='.f-content-awards-right__wrapper-info__container__content --li-ec'>
        <b>PUESTO 3 al 5: </b> 1 Kit de Productos Nosotras + lonchera
      </li>
    </>
  }else{
    text = <>
      <li><b>PUESTO 1:</b> 1 Iphone 14</li>
      <li><b>PUESTO 2 al 5:</b> 1 Tablet 32 GB</li>
      <li><b>PUESTO 6 al 10: </b> Set de estuches + productos Nosotras</li>    
    </>
  }

  return (
    <>
      {text}
    </>
  )
}
const topByCountry = () => {
  let text;
  if (ec || cl) {
    text = <>
      ¡Se premiarán las <br /> <b> 5 mejores</b> jugadoras!
    </>
  }else{
    text = <>
      ¡Se premiarán las <br /> <b> 10 mejores</b> jugadoras!
    </>
  }

  return (
    <>
      {text}
    </>
  )
}
export const ImageByCountry1 = ({isMobile, classname}) => {
  let image_mobile;
  let image_desktop;
  if (ec) {
    image_mobile = images.awardsMbEc;
    image_desktop = images.awardsPcEc;
  } else if (arg) {
    image_mobile = images.awardsMbArg;
    image_desktop = images.awardsPcArg;
  } else if (cl) {
    image_mobile = images.awardsMbCl;
    image_desktop = images.awardsPcCl;
  }else {
    image_mobile = images.awardsMbCo;
    image_desktop = images.awardsPcCo;
  }
  
  return (
    <img
      src={isMobile ? image_mobile : image_desktop}
      alt="premios para las ganadoras"
      className={` ${classname} ${ec ? "image_ec" : ""}`}
    />
  )
}

export const text_replica_content_awards1 = Text1ByCountry()
export const text_replica_content_awards2 = Text2ByCountry()
export const text_replica_content_awards3 = topByCountry()
export const text_replica_content_awards6 = Text3ByCountry()
export const text_replica_content_description_awards = rewardByCountry()
